(function () {
  function getCookie(name) {
    var parts = document.cookie ? document.cookie.split("; ") : [];
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i];
      var separator = part.indexOf("=");
      var key = separator >= 0 ? part.slice(0, separator) : part;
      if (key === name) {
        return decodeURIComponent(separator >= 0 ? part.slice(separator + 1) : "");
      }
    }
    return "";
  }

  function getTrackingPayload() {
    var gaCookie = getCookie("_ga");
    var match = String(gaCookie || "").match(/^GA\d+\.\d+\.(.+)$/);

    return {
      ga_cookie: gaCookie,
      ga_client_id: match ? match[1] : "",
    };
  }

  window.CintaModernaGa4Tracking = Object.assign({}, window.CintaModernaGa4Tracking, {
    getCookie: getCookie,
    getTrackingPayload: getTrackingPayload,
  });
})();
